export enum TourType {
  Direct = "DIRECT",
  Collection = "COLLECTION",
  Distribution = "DISTRIBUTION",
  RECURRING = "RECURRING",
}